import projects from '@/json/projects'
import * as types from '../mutations-types.js'

const state = {
  index: 0,
  project: null,
}

const getters = {
  index: state => state.index,
}

const mutations = {
  [types.SET_INDEX](state, value){
    state.index = value
  },
  setProject(state, project) {
    state.project = project;
  }
}

const actions = {
  getProject({commit}, slug){
    const project = projects.find(project => {
      return project.slug === slug;
    })

    commit('setProject', project);
    return project;
  }
}

export default{
  state,
  getters,
  mutations,
  actions
}

function findIndex(neddle){
  let index = 0
  data.forEach((value, key) => {
    if (value.title.toLowerCase() === neddle.toLowerCase()){
      index = key
    }
  });
  return index
}


// WEBPACK FOOTER //
// ./src/store/modules/projects.js